import { render, staticRenderFns } from "./OdontogramItem.vue?vue&type=template&id=a62f5800&scoped=true"
import script from "./OdontogramItem.vue?vue&type=script&lang=js"
export * from "./OdontogramItem.vue?vue&type=script&lang=js"
import style0 from "./OdontogramItem.vue?vue&type=style&index=0&id=a62f5800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62f5800",
  null
  
)

export default component.exports